module.exports = __webpack_public_path__ + "static/media/recruit_480_art.6b86d362.png";